module.exports = __webpack_public_path__ + "static/media/circle_red.0994325d.png";